import React, { useCallback } from "react";
import { sendPreAuthAudit } from '../../shared/helpers/';
import { Auth } from "aws-amplify";
import { useLoginStore } from "../../../state/LoginStore";

export function useHandleMFASubmit(
    user: any,
    setToken: Function,
    setLoginLoading: React.Dispatch<boolean>,
    setAuthFlowErrorType: React.Dispatch<string>,
    setAuthFlowError: React.Dispatch<string>) {

    const setSeverity = useLoginStore((state) => state.setSeverity);
    const setOpenAlert = useLoginStore((state) => state.setOpenAlert);

    const handleMFASubmit = useCallback((code: any) => {
        (async () => {
            if (user.challengeName === "SOFTWARE_TOKEN_MFA") {
                try {
                    console.log(`debug loginLoading MFA Submitted, attempting login`);
                    try {
                        await sendPreAuthAudit(user.username, "MFA Submitted", `MFA Submitted by ${user.username}`);
                    } catch (err) {
                        console.error(`Failed login attempt audit ${err}`)
                    }
                    const res = await Auth.confirmSignIn(
                        user,
                        code,
                        "SOFTWARE_TOKEN_MFA",
                        { 'product_scope': 'mc' }
                    );
                    if (res) {
                        setToken(res);
                        console.log('debug loginLoading setting login loading to true')
                        setLoginLoading(true)
                    }
                } catch (e: any) {
                    try {
                        await sendPreAuthAudit(user.username, "MFA Failed", `MFA Bad Code by ${user.username}`);
                    } catch (err) {
                        console.error(`Failed login attempt audit ${err}`)
                    }
                    setAuthFlowErrorType(e.code);
                    setAuthFlowError(e.message);
                    setSeverity("error")
                    setOpenAlert(true)
                }
            } else if (user.challengeName === "MFA_SETUP" || !user.challengeName) {
                try {
                    let loggedInUser = await Auth.verifyTotpToken(user, code);
                    if (loggedInUser) {
                        await Auth.setPreferredMFA(user, "TOTP");
                        setToken(user);
                        setLoginLoading(true)
                    }
                } catch (e: any) {
                    setSeverity("error")
                    setOpenAlert(true)
                    setAuthFlowErrorType(e.code);
                    setAuthFlowError(e.message);
                }
            }
            setLoginLoading(false);
        })()

    }, [user, setAuthFlowError, setAuthFlowErrorType, setLoginLoading, setOpenAlert, setSeverity, setToken])

    return { handleMFASubmit }


}